import { RuleType } from "winslow-core";

export interface RuleOption {
  id: RuleType;
  label: string;
}

export const RULE_OPTIONS: RuleOption[] = [
  { id: RuleType.IS, label: "Is" },
  { id: RuleType.IS_NOT, label: "Is Not" },
  { id: RuleType.IS_ONE_OF, label: "Is One Of" },
  { id: RuleType.IS_NOT_ONE_OF, label: "Is Not One Of" },
  { id: RuleType.CONTAINS, label: "Contains" },
  { id: RuleType.DOES_NOT_CONTAIN, label: "Does Not Contain" },
];
